import { ProgressReportViewer } from "components/features/ProgressReportViewer";
import { useQuery } from "hooks/useQuery";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "utils/api";

const ProgressReportViewModePage = () => {
  const { id, sectionId } = useParams();
  const query = useQuery();
  const targetObject = query.get("object");
  const showShortestPath = query.get("showShortestPath") === "true";
  const [isLoading, setIsLoading] = useState(true);
  const [sectionData, setSectionData] = useState<any>(null);

  useEffect(() => {
    const fetchSectionPlan = async () => {
      setIsLoading(true);
      const section = await api.fetchSectionPlan(id, sectionId);
      setSectionData(section);
      setIsLoading(false);
    };
    fetchSectionPlan();
  }, [id, sectionId]);

  if (isLoading) {
    return <></>;
  }

  if (!id || !sectionId || !sectionData) {
    return <div>Invalid project or section</div>;
  }

  return (
    <div className="h-screen w-screen">
      <ProgressReportViewer
        sectionData={(sectionData as any)?.section}
        projectId={id}
        selectedObjectId={targetObject}
        isViewMode={true}
        autoShowShortestPath={showShortestPath}
      />
    </div>
  );
};

export default ProgressReportViewModePage;
